// ITEM19: apply term and search tab in one confirmed action, avoiding a race
// between the old debounce and the guard that exits an empty search.
export const createTicketSearchHandlers = ({
  setSearchParam,
  setTab,
  setForceSearch,
  setFilter
}) => ({
  handleSearch: event => {
    if (event.target.value === "") {
      setSearchParam("");
      setForceSearch(previous => !previous);
    }
  },
  handleSearchKeyDown: event => {
    if (
      event.key !== "Enter" ||
      event.nativeEvent?.isComposing ||
      event.keyCode === 229
    ) {
      return;
    }
    event.preventDefault();
    const searchedTerm = event.target.value.trim().toLowerCase();
    setSearchParam(searchedTerm);
    if (searchedTerm) setTab("search");
    setForceSearch(previous => !previous);
    setFilter(false);
  }
});
